import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { UsuariosRoutingModule } from './usuarios-routing.module';
import { ComponentesCompartidosModule } from '../componentes-compartidos/componentes-compartidos.module';
import { PaginaUsuariosComponent } from './pagina-usuarios/pagina-usuarios.component';
import { SubidaMasivaComponent } from './subida-masiva/subida-masiva.component';
import { UsuariosService } from 'src/app/servicios/usuarios.service';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';

@NgModule({
  declarations: [
    PaginaUsuariosComponent,
    SubidaMasivaComponent
  ],
  exports: [
    PaginaUsuariosComponent
  ],
  imports: [
    MatIconModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    CommonModule,
    ReactiveFormsModule,
    UsuariosRoutingModule,
    ComponentesCompartidosModule,
    MatCheckboxModule
  ],
  providers: [
    UsuariosService,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class UsuariosModule { }
